import { ReactComponent as IconPen } from "../../../styles/assets/svg/icon_foodPen.svg";
import { ReactComponent as IconDelete } from "../../../styles/assets/svg/icon_dietDelete.svg";
import { ReactComponent as IconPlus } from "../../../styles/assets/svg/icon_foodPlus.svg";
import { ReactComponent as IconMinus } from "../../../styles/assets/svg/icon_foodMinus.svg";
import { ReactComponent as IconDownArrow } from "../../../styles/assets/svg/icon_down_arrow.svg";
import { useState } from "react";
import { ModalFoodInfoFix } from "src/components/molecules/ModalFoodInfoFix";

export interface infoProps {
  data: any[];
  setFoodInfo: (e: any) => void;
}
export const FoodInfo = ({ data, setFoodInfo }: infoProps) => {
  const [modalShow, setModalShow] = useState<boolean>(false);
  const [selectedFoodId, setSelectedFoodId] = useState<any | null>(null);

  const openModal = (idx: number) => {
    const food = data[idx] || null;
    setSelectedFoodId({ food, idx });
    setModalShow(true);
  };

  const increment = (idx: number) => {
    setFoodInfo((prev: any[]) =>
      prev.map((f: any, fIdx: number) =>
        fIdx === idx ? { ...f, qty: (Number(f.qty) || 0) + 1 } : f
      )
    );
  };

  const decrement = (idx: number) => {
    setFoodInfo((prev: any[]) =>
      prev.map((f: any, fIdx: number) =>
        fIdx === idx ? { ...f, qty: Math.max((Number(f.qty) || 1) - 1, 1) } : f
      )
    );
  };

  const removeFood = (idx: number) => {
    setFoodInfo((prev: any[]) =>
      prev.filter((_, fIdx: number) => fIdx !== idx)
    );
  };
  return (
    <>
      {data.length > 0 &&
        data.map((food, idx) => (
          <div
            key={idx}
            style={{
              width: "100%",
              height: "100%",
              padding: 16,
              background: "white",
              borderRadius: 8,
              outline: "1.50px var(--neutral-100, #F5F5F5) solid",
              outlineOffset: "-1.50px",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: 8,
              display: "inline-flex",
            }}
          >
            <div
              style={{
                alignSelf: "stretch",
                justifyContent: "space-between",
                alignItems: "flex-start",
                display: "flex",
              }}
            >
              <div
                style={{
                  alignSelf: "stretch",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  display: "flex",
                }}
              >
                <span
                  style={{
                    color: "var(--neutral-700, #404040)",
                    fontSize: 16,
                    fontWeight: "500",
                    lineHeight: "24px",
                  }}
                >
                  {food.mealName || "새 음식"}
                </span>
                <span
                  style={{
                    color: "var(--neutral-400, #A3A3A3)",
                    fontSize: 14,
                    fontWeight: "500",
                    lineHeight: "20px",
                  }}
                >
                  {food.calorie || 0} Kcal
                </span>
              </div>
              <div
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 8,
                  display: "flex",
                }}
              >
                <div
                  style={{
                    padding: 8,
                    background: "var(--neutral-100, #F5F5F5)",
                    borderRadius: 8,
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                    cursor: "pointer",
                  }}
                  onClick={() => openModal(idx)}
                >
                  <IconPen />
                </div>
                <div
                  style={{
                    padding: 8,
                    background: "var(--neutral-100, #F5F5F5)",
                    borderRadius: 8,
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                    cursor: "pointer",
                  }}
                >
                  <IconDelete onClick={() => removeFood(idx)} />
                </div>
              </div>
            </div>

            <div
              style={{
                alignSelf: "stretch",
                justifyContent: "center",
                alignItems: "center",
                gap: 8,
                display: "flex",
              }}
            >
              <div
                style={{
                  flex: "1 1 0",
                  padding: "14px 12px",
                  boxShadow: "0px 4px 11px rgba(0, 0, 0, 0.04)",
                  borderRadius: 8,
                  outline: "1px var(--neutral-100, #F5F5F5) solid",
                  outlineOffset: "-1px",
                  justifyContent: "space-between",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <IconMinus
                  style={{ cursor: "pointer" }}
                  onClick={() => decrement(idx)}
                />
                <div
                  style={{
                    justifyContent: "center",
                    display: "flex",
                    flexDirection: "column",
                    color: "var(--neutral-600, #525252)",
                    fontSize: 14,
                    fontWeight: "500",
                    lineHeight: "20px",
                  }}
                >
                  {food.qty ?? 1}
                </div>
                <IconPlus
                  style={{ cursor: "pointer" }}
                  onClick={() => increment(idx)}
                />
              </div>
              <div
                style={{
                  flex: "1 1 0",
                  padding: "14px 12px",
                  boxShadow: "0px 4px 11px rgba(0, 0, 0, 0.04)",
                  borderRadius: 8,
                  outline: "1px var(--neutral-100, #F5F5F5) solid",
                  outlineOffset: "-1px",
                  justifyContent: "space-between",
                  alignItems: "center",
                  display: "flex",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    flex: "1 1 0",
                    justifyContent: "space-between",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      flex: "1 1 0",
                      color: "var(--neutral-600, #525252)",
                      fontSize: 14,
                      fontWeight: "500",
                      lineHeight: "20px",
                    }}
                  >
                    {food.unit || "인분"}
                  </div>
                  <IconDownArrow style={{ cursor: "pointer" }} />
                  <select
                    value={food.unit || "인분"}
                    onChange={(e) =>
                      setFoodInfo((prev: any[]) =>
                        prev.map((f, fIdx) =>
                          fIdx === idx ? { ...f, unit: e.target.value } : f
                        )
                      )
                    }
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      opacity: 0,
                      cursor: "pointer",
                      color: "var(--neutral-600, #525252)",
                      fontSize: 14,
                      fontWeight: "500",
                      lineHeight: "20px",
                    }}
                  >
                    <option value="인분">인분</option>
                    <option value="개">개</option>
                  </select>
                </div>
              </div>
            </div>

            {modalShow && selectedFoodId && (
              <ModalFoodInfoFix
                data={selectedFoodId}
                setFoodInfo={setFoodInfo}
                onClose={() => setModalShow(false)}
              />
            )}
          </div>
        ))}
    </>
  );
};
